import { useState } from 'react';

import StyledTableToolbar from '@/components/shared/Table/features/StyledTableToolbar';
import { buildApiUrl } from '@/config/runtimeConfig';
import { useAuth } from '@/contexts/AuthContext';
import { useSnackbar } from '@/hooks/useSnackbar';
import { fetchAndDownload } from '@/shared/api/downloadFile';
import { handleSnackbarError } from '@/shared/utils/errorHandler';

interface EditGroupExportProps {
  organizationId: number;
  groupId?: number;
  isExportDisabled: boolean;
  url: string;
  fileName: string;
}

function EditGroupExport({ organizationId, groupId, isExportDisabled, url, fileName }: EditGroupExportProps) {
  const { getAccessToken } = useAuth();
  const snackbar = useSnackbar();

  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const handleExport = async () => {
    if (!organizationId || !groupId) {
      console.error('No organizationId or allocationGroupId available for export');
      return;
    }

    setIsExportLoading(true);

    try {
      await fetchAndDownload({
        url: buildApiUrl(url),
        getToken: getAccessToken,
        fileName: fileName,
      });
    } catch (err) {
      console.error('Export error:', err);
      handleSnackbarError(err, snackbar);
    } finally {
      setIsExportLoading(false);
    }
  };
  return (
    <StyledTableToolbar
      isColumnVisibilityEnabled={false}
      isDndEnabled={false}
      exportFeature={{
        onExport: handleExport,
        isExportLoading: isExportLoading,
        isExportDisabled: isExportDisabled,
      }}
    />
  );
}

export default EditGroupExport;
